import { RevisionRecurrence } from "@components/revision-info/models/revision-recurrence.model";

export class RevisionOperation {
    public operationId: number;
    public name: string;
    public recurrences: RevisionRecurrence[];

    constructor(revisionOperation: any = {}) {
        this.operationId = revisionOperation.operationId || null;
        this.name = revisionOperation.name || '';
        this.recurrences = (revisionOperation.recurrences || [])
            .map(recurrence => new RevisionRecurrence(recurrence));
    }
}
